/* 🤖 this file was generated by svg-to-ts */
export const matIconTransitEnterexit: {
  name: 'transit-enterexit';
  data: string;
} = {
  name: 'transit-enterexit',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"/></svg>`
};
